import {
  Form,
  Button,
  Col,
  Input,
  Modal,
  Row,
  Spin,
  Typography,
  Select,
  Switch,
  Space,
  Collapse,
  Divider,
  Progress
} from 'antd';
import {
  MinusOutlined,
  PlusOutlined,
  MinusCircleOutlined
} from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { getCourses } from '../../../services/courseService';
import { getCourseOffers } from '../../../services/courseOfferService';
import { getTrainers } from '../../../services/trainerServices';
import { beforeImageUpload } from '../../../utilities/imageUpload';
import ImageUploadSection from '../../ImageUploadSection';
const { Panel } = Collapse;
const { Text } = Typography;
const allLabel = 'All';

function BasicInfoEdit({
  type,
  isOpen,
  toggle,
  initialValues,
  onSubmit,
  setCommissionPerc,
  commissionPerc,
  status
}) {
  const [form] = Form.useForm();
  const [trainers, setTrainers] = useState([]);
  const [allTrainers, setAllTrainers] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [trainerExists, setTrainerExists] = useState(true);
  const [courses, setCourses] = useState([]);

  const [courseOffers, setCourseOffers] = useState([]);
  const allOptions = [{ label: allLabel, value: allLabel }];

  const increase = () => {
    if (commissionPerc < 100) {
      setCommissionPerc(commissionPerc + 5);
      form.setFieldsValue({
        comissionPercentage: commissionPerc
      });
    }
  };

  const decline = () => {
    if (commissionPerc > 0) {
      setCommissionPerc(commissionPerc - 5);
      form.setFieldsValue({
        comissionPercentage: commissionPerc
      });
    }
  };

  useEffect(() => {
    setTrainers(allTrainers);
  }, [allTrainers]);

  const onChangeTrainerExists = (e) => {
    setTrainerExists(e);
  };
  useEffect((e) => {
    setFetching(true);
    getTrainers(0, 0, { sortBy: 'firstName', sortOrder: 'asc' })
      .then((response) => {
        const trainerList = response.data.paginatedList;
        const data = trainerList.map((trainer) => ({
          label: `${trainer.firstName} ${trainer.lastName}`,
          value: trainer._id
        }));
        setAllTrainers(data);
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting trainers from the backend failed!');
      });
    setFetching(false);
  }, []);

  const fetchTrainers = (value) => {
    const filteredTrainers = allTrainers.filter((item) => {
      const substring = item.label.substr(0, value.length);
      return substring.toLowerCase() === value.toLowerCase();
    });
    setTrainers(filteredTrainers);
  };

  useEffect(() => {
    if (type === 'ADD') {
      getCourses(1, 1000, {})
        .then((response) => {
          const data = response.data.paginatedList.map((course) => ({
            label: course.code,
            value: course.code
          }));
          setCourses(data);
        })
        .catch((error) => {
          console.log('Error getting courses from the backend:', error);
          alert(
            'Getting courses for creator form from the backend failed!'
          );
        });

      getCourseOffers(1, 1000, {})
        .then((response) => {
          const data = response.data.paginatedList.map((course) => ({
            label: course.code,
            value: course.code
          }));
          setCourseOffers(data);
        })
        .catch((error) => {
          console.log('Error getting courses from the backend:', error);
          alert(
            'Getting courses for creator form from the backend failed!'
          );
        });
    }
  }, [initialValues]);

  return (
    <Modal
      title={type === 'ADD' ? 'Add Creator' : 'Edit Basic info'}
      visible={isOpen}
      footer={null}
      onCancel={toggle}
      forceRender={true}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 14 }}
          onFinish={onSubmit}
          initialValues={initialValues}
          form={form}>
          <Form.Item
            label="First Name"
            name="firstName"
            rules={[
              { required: true, message: 'Please input first name!' }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="Last Name"
            name="lastName"
            rules={[
              { required: true, message: 'Please input last name!' }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: 'Please input email!' }]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="University"
            name="university"
            rules={[
              { required: true, message: 'Please input university!' }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="Academy Name"
            name="academyName"
            rules={[
              { required: true, message: 'Please input academy name!' }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label="Facebook Academy Link"
            name="fbAcademyLink"
            rules={[
              {
                required: true,
                message: 'Please input facebok academy link!'
              }
            ]}>
            <Input />
          </Form.Item>

          {type === 'ADD' && (
            <>
              <Form.Item
                label="Does the trainer exist?"
                name="trainerExists"
                rules={[{ required: false }]}>
                <div align="center">
                  <Switch
                    defaultChecked
                    onChange={onChangeTrainerExists}
                  />
                </div>
              </Form.Item>
              <Form.Item
                label="trainer"
                name="trainerId"
                rules={[
                  {
                    required: trainerExists
                  }
                ]}>
                <Select
                  mode={''}
                  placeholder="Search trainer"
                  notFoundContent={fetching ? <Spin size="small" /> : null}
                  filterOption={false}
                  showSearch={true}
                  onSearch={fetchTrainers}
                  dropdownRender={(menu) => <div>{menu}</div>}
                  disabled={!trainerExists}>
                  {trainers?.map((item) => (
                    <Select.Option value={item.value}>
                      <Panel header={item.label} key="1"></Panel>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </>
          )}
          <Form.Item
            label="Sender Email"
            name="senderEmail"
            rules={[
              {
                required: false,
                message: 'default: hello@nasacademy.com'
              }
            ]}>
            <Input placeholder="default: hello@nasacademy.com" />
          </Form.Item>
          <Form.Item label="Update-To Details" name="updateTo">
            <Form.List label="Update-to details" name="updateTo">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, fieldKey, ...restField }) => (
                    <Space
                      key={key}
                      style={{ display: 'flex', marginBottom: 8 }}
                      align="baseline">
                      <Form.Item
                        {...restField}
                        name={[name, 'name']}
                        fieldKey={[fieldKey, 'name']}
                        rules={[
                          {
                            required: true,
                            message: 'missing update-to name!'
                          }
                        ]}>
                        <Input placeholder="name" />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'email']}
                        fieldKey={[fieldKey, 'email']}
                        rules={[
                          {
                            required: true,
                            message: 'Missing update-to email'
                          }
                        ]}>
                        <Input placeholder="email" />
                      </Form.Item>

                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}>
                      Add field
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Form.Item>

          <Collapse>
            <Panel header="Banner Image in Creator Portal" key="2">
              <section>
                <ImageUploadSection
                  beforeImageUpload={beforeImageUpload}
                  nest={['bannerImgData']}
                  // Need to insert name of course here `ssr-academy/${courseName}/cohort/png/`
                  path={`na-portal/CreatorBanners/`}
                  bucket={'image-assets.nasdaily.com'}
                  form={form}
                  hideResolution={{ desktop: false, mobile: false }}
                  imgRequired={{ mobile: true, desktop: true }}
                  showWebP={true}
                  isDesktopInput={true}
                />
              </section>
            </Panel>
          </Collapse>
          <Collapse>
            <Panel header="Thumbnail Image in Creator Portal" key="2">
              <section>
                <ImageUploadSection
                  beforeImageUpload={beforeImageUpload}
                  nest={['thumbnailImgData']}
                  path={`na-portal/CourseThumbnails/`}
                  bucket={'image-assets.nasdaily.com'}
                  form={form}
                  hideResolution={{ desktop: false, mobile: false }}
                  imgRequired={{ mobile: true, desktop: true }}
                  showWebP={true}
                />
              </section>
            </Panel>
          </Collapse>
          <Divider />
          {type === 'ADD' && (
            <>
              <Form.Item
                label="Comission Percentage"
                name="commissionPercentage"
                rules={[{ required: true }]}>
                <div align="center">
                  <Progress
                    type="circle"
                    name="commissionPercentage"
                    percent={commissionPerc}
                    format={(value) =>
                      value == 100 ? '100%' : `${value}%`
                    }
                  />
                  <Button.Group>
                    <Button onClick={decline} icon={<MinusOutlined />} />
                    <Button onClick={increase} icon={<PlusOutlined />} />
                  </Button.Group>
                </div>
              </Form.Item>
              <Form.Item
                label="Courses Applicable"
                name="coursesApplicable"
                required={true}>
                {courses && courses.length > 0 ? (
                  <Select
                    options={[...allOptions, ...courses]}
                    required={true}
                    placeholder={'Select Applied Courses'}
                    mode="multiple"
                    notFoundContent={null}
                    filterOption={(input, option) =>
                      option.label
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  />
                ) : null}
              </Form.Item>

              <Form.Item
                label="Course Offers Applicable"
                name="courseOffersApplicable"
                required={true}>
                {courseOffers && courseOffers.length > 0 ? (
                  <Select
                    options={[...allOptions, ...courseOffers]}
                    placeholder={'Select Applied Course Offers'}
                    mode="multiple"
                    required={true}
                    notFoundContent={null}
                    filterOption={(input, option) =>
                      option.label
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  />
                ) : null}
              </Form.Item>
            </>
          )}
          {status.type === 'ERROR' ? (
            <Text type="danger">{status.message}</Text>
          ) : null}
          {status.type === 'SUCCESS' ? (
            <Text type="success">Successfully Updated!</Text>
          ) : null}
          <Row justify="end">
            <Col>
              <Button type="primary" htmlType="submit">
                {type === 'ADD' ? 'Add' : 'Update'}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Modal>
  );
}

export default BasicInfoEdit;
